/**
 * Traduções de gerenciamento de conta
 * Inclui: Definir senha, cancelamento de conta
 */
export default {
  accountManagement: 'Gerenciamento de conta',
  setPassword: 'Definir Senha',
  accountCancellation: 'Cancelamento de Conta',
  enterNewPassword: 'Digite uma nova senha',
  enterNewPasswordAgain: 'Digite a nova senha novamente',
  passwordRequirements: 'A senha deve ter de 8 a 16 caracteres e conter letras e números',
  save: 'Salvar',
  accountToBeCanceled: 'Conta a ser cancelada',
  pleaseNote: 'Observe que, uma vez que a conta é cancelada:',
  cancelNote1: '1. Você nunca mais poderá entrar e usar a conta;',
  cancelNote2: '2. Quaisquer ativos virtuais dentro da conta, como diamantes, presentes, molduras de retrato e banners de entrada, serão esvaziados;',
  cancelNote3: '3. Todas as informações da conta, incluindo seu perfil e retrato, serão apagadas;',
  cancelNote4: '4. Sua lista de amigos, registros de chamadas e histórico de chat serão apagados.',
  confirmAndContinue: 'Confirmar e Continuar',
  passwordMismatch: 'As duas senhas não correspondem',
  passwordFormatError: 'A senha deve ter de 8 a 16 caracteres e conter letras e números',
  setPasswordSuccess: 'Senha definida com sucesso',
  cancelAccountSuccess: 'Solicitação de cancelamento de conta enviada',
}
